function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesWiredInternetFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 28h24v-7H4v7zm24 2a2 2 0 002-2v-7a2 2 0 00-2-2H4a2 2 0 00-2 2v7a2 2 0 002 2h24z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 8.5a1 1 0 011 1V20a1 1 0 11-2 0V9.5a1 1 0 011-1zM13 23v3h-2v-3h2zM9 23v3H7v-3h2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 17h4v2h-4v-2zM2 3h4v3H2V3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5v3.5c0 .674.258.999.522 1.188.314.227.721.312.978.312H13c1.326 0 2.251.575 2.812 1.353.523.728.688 1.57.688 2.147 0 1.326-.575 2.251-1.353 2.811A3.791 3.791 0 0113 17h-3c-.474 0-.674.175-.788.334-.152.21-.212.493-.212.666v3H7v-3c0-.493.14-1.211.588-1.834C8.074 15.49 8.874 15 10 15h3c.257 0 .664-.085.978-.312.264-.19.522-.514.522-1.188 0-.257-.085-.664-.312-.978-.19-.264-.514-.522-1.188-.522H6.5c-.577 0-1.42-.165-2.147-.688C3.575 10.752 3 9.825 3 8.5V5h2z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesWiredInternetFilled;